// extracted by mini-css-extract-plugin
export default {"submmitBtn":"index_submmitBtn_SSE6O","errrTip":"index_errrTip_-4RJa"};